/** Sérialise une date-only (valeur d'un `<input type="date">`, « YYYY-MM-DD ») en
 * ISO UTC à midi. Midi UTC conserve le même jour calendaire à l'affichage local
 * (toLocaleDateString) sur toute la plage métropole + DOM-TOM (UTC-10 à UTC+11),
 * contrairement à T00:00:00Z (recule d'un jour en fuseau négatif) ou T23:59:59Z
 * (avance d'un jour en fuseau positif, ex. métropole UTC+1/+2). */
export function dueDateToIso(day: string): string {
  const [y, m, d] = day.split("-").map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d, 12)).toISOString();
}

const pad2 = (n: number) => (n < 10 ? "0" : "") + n;

/** Clé jour locale « YYYY-MM-DD » d'une Date. */
export function dayKey(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

/** Clé jour « YYYY-MM-DD » d'un ISO datetime (jour calendaire UTC — cohérent
 * avec dueDateToIso qui ancre à midi UTC). */
export function isoToDayKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

export function todayKey(): string {
  return dayKey(new Date());
}

/** Affiche « 12 juil. » (année ajoutée si différente de l'année en cours). */
export function formatDay(key: string): string {
  const [y, m, d] = key.split("-").map(Number) as [number, number, number];
  const date = new Date(Date.UTC(y, m - 1, d, 12));
  const opts: Intl.DateTimeFormatOptions =
    y === new Date().getFullYear()
      ? { day: "numeric", month: "short" }
      : { day: "numeric", month: "short", year: "numeric" };
  return date.toLocaleDateString("fr-FR", { ...opts, timeZone: "UTC" });
}

export function isOverdue(dueKey: string): boolean {
  return dueKey < todayKey();
}
